import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    position: relative;
    height: 100vh;
    isolation: isolate;
    .bg-image {
        z-index: 1;
        position: absolute;
        inset: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .cover {
        z-index: 2;
        position: absolute;
        inset: 0;
        background-color: #00000088;
    }
    .data {
        z-index: 3;
        width: calc(50% - 140px);
        padding: 0 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title {
            font-size: 3rem;
            font-weight: 800;
            color: #fff;
        }
        .desc {
            margin: 1rem 0;
            font-size: 1rem;
            color: #fff;
        }
        .ctas {
            display: flex;
            gap: 12px;
            .cta {
                cursor: pointer;
                flex-grow: 1;
                border: 1px solid #fff;
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: 600;
                text-align: center;
                padding: 0.75rem 0;
                color: #fff;
                text-decoration: none;
                &.cta-btn-1 {
                    border: 1px solid var(--prime-2);
                    :hover {
                        background-color: #00000020;
                    }
                }
                &.cta-btn-2 {
                    background-color: var(--prime-2);
                    border: 1px solid var(--prime-2);
                    color: #fff;
                    :hover {
                        background-color: var(--prime-2);
                    }
                }
            }
        }
    }
    @media (max-width: 850px){
        .data { 
            justify-content: end;
            width: calc(100% - 32px);
            padding: 0 16px 7rem;
            .ctas {
                flex-direction: column;
            }
        }
    }
`;

export default function IntroFirst({pageHeight, data}) {
    const scrollOneScreen = () => {
        window.scrollTo({
            top: pageHeight - 60,
            behavior: "smooth"
        })
    }
    const makeCta = (cta) => {
        switch(cta.type){
            case "scroll":
                return (
                    <div className="cta cta-btn-1" onClick={scrollOneScreen}>
                        {cta.title}
                    </div>
                )
            case "link":
                return (
                    <a href={cta.route} target={cta.target} className="cta cta-btn-2">
                        {cta.title}
                    </a>
                )
            case "link-inside":
                return (
                    <Link to={cta.route} target={cta.target} className="cta cta-btn-2">
                        {cta.title}
                    </Link>
                )
            default:
                return;
        }
    }
    return (
      <Style style={{height: `${pageHeight}px`}}>
        <div className="bg-image">
            <img src={data.data.bgimage} alt={data.title}/>
        </div>
        <div className="cover">
        </div>
        <div className="data">
            <div className="title">
                {data.data.title}
            </div>
            <div className="desc">
                {data.data.desc}
            </div>
            <div className="ctas">
                {makeCta(data.data.cta1)}
                {makeCta(data.data.cta2)}
            </div>
        </div>
      </Style>
  );
}
